import {FileText, Paperclip} from 'lucide-react'
import { CASE_STATUS_META, categoryLabel } from '@/lib/caseCategories'
import type { WorkCase } from '@/hooks/useCases'

interface CaseListProps {
  cases: WorkCase[]
  loading: boolean
  emptyText?: string
}

function CaseList({ cases, loading, emptyText }: CaseListProps) {
  if (loading && cases.length === 0) {
    return <p className="text-sm text-slate-400">Cargando casos...</p>
  }

  if (cases.length === 0) {
    return (
      <p className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
        {emptyText || 'Aún no has abierto ningún caso.'}
      </p>
    )
  }

  return (
    <div className="space-y-3">
      {cases.map((c) => {
        const meta = CASE_STATUS_META[c.status] || CASE_STATUS_META.abierto
        return (
          <article key={c._id} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <FileText size={15} className="shrink-0 text-amber-500" />
                  <h3 className="text-sm font-semibold text-slate-900">{c.title}</h3>
                </div>
                <p className="mt-0.5 text-xs text-slate-500">
                  {categoryLabel(c.category)} · contra {c.targetName || 'N/D'}
                </p>
              </div>
              <span className={`shrink-0 rounded-md px-2.5 py-1 text-xs font-medium ${meta.cls}`}>{meta.label}</span>
            </div>

            <p className="mt-2 text-sm text-slate-600">{c.description}</p>

            <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-slate-400">
              <span>Abierto el {new Date(c.createdAt).toLocaleDateString('es-MX')}</span>
              {c.evidenceUrls && c.evidenceUrls.length > 0 && (
                <span className="inline-flex items-center gap-1">
                  <Paperclip size={12} /> {c.evidenceUrls.length} evidencia(s)
                </span>
              )}
            </div>

            {c.resolution && (
              <div className="mt-3 rounded-lg bg-slate-50 px-3 py-2">
                <p className="text-xs font-semibold text-slate-700">Resolución de Beeznz Work</p>
                <p className="mt-0.5 text-xs text-slate-600">{c.resolution}</p>
              </div>
            )}
          </article>
        )
      })}
    </div>
  )
}

export default CaseList
